'use client';

import { useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';

import useReducedMotion from '@/utils/useReducedMotion';
import useBetterMediaQuery from '@/utils/useBetterMediaQuery';
import theme from '@/utils/styles-variables';
import { Container as ContainerText } from '@swordhealth/ui-corporate';
import VideoPlayerModal from '@/components/shared/VideoPlayerModal';
import ButtonPlay from './ButtonPlay';
import VideoPreview from './VideoPreview';

import {
  Container,
  Wrapper,
  Content,
  Logo,
  Description,
  WrapperText,
  VideoContainerTablet,
} from './styles';

import { Heading } from '@swordhealth/ui-corporate';

const CinematicHero = ({ content }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const prefersReducedMotion = useReducedMotion();
  const isTablet = useBetterMediaQuery(`(max-width: ${theme.breakpoints.max_md}px)`);

  if (!content) return null;

  const { video, info } = content;

  const logoUrl = isTablet ? `/sword__colored.svg` : `/sword_white.svg`;

  return (
    <>
      <Container>
        {!isTablet && (
          <VideoPreview
            prefersReducedMotion={prefersReducedMotion}
            videoUrl={video.videoPreview.data.attributes.url}
          />
        )}
        <Wrapper>
          <ContainerText>
            <WrapperText>
              <Content>
                <Link href="/" target="_blank" rel="noopener noreferrer">
                  <Logo>
                    <Image
                      loading="eager"
                      src={logoUrl}
                      alt="Sword Health Digital MSK solutions"
                      height={28}
                      width={113}
                    />
                  </Logo>
                </Link>
                <Heading as="h1" size="3xl">
                  {info.title}
                </Heading>
                {info.description && <Description>{info.description}</Description>}
              </Content>
              {!isTablet && (
                <ButtonPlay handleOnClick={() => setModalIsOpen(true)} text={video.buttonLabel} />
              )}
            </WrapperText>
          </ContainerText>
          <VideoPlayerModal
            modalIsOpen={modalIsOpen}
            closeModal={() => setModalIsOpen(false)}
            videoURL={video.videoURL}
          />
        </Wrapper>
      </Container>
      {isTablet && (
        <VideoContainerTablet>
          <VideoPreview
            prefersReducedMotion={prefersReducedMotion}
            videoUrl={video.videoPreview.data.attributes.url}
          />
          <ButtonPlay handleOnClick={() => setModalIsOpen(true)} text={video.buttonLabel} />
        </VideoContainerTablet>
      )}
    </>
  );
};

CinematicHero.defaultConfig = {
  rounded: false,
  colored: false,
  spaceBottom: false,
  spaceTop: false,
  marginBottom: false,
};

export default CinematicHero;
